import React from "react";
import { Button, NoData, PageTitle } from "../../../../../../components";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

const PaymentMethods = () => {
  const { userData: loginUserData } = useLoginUser();
  return (
    loginUserData?.role?.module===4?
    <div className="flex flex-col justify-center items-center flex-1 overflow-auto ">
      <div className="flex flex-col justify-center items-center m-10">
        <h1 className="flex font-bold text-center items-center  break-words">
          Payment Methods
        </h1>
        <h2 className="flex font-bold text-center items-center  break-words">
          Coming soon
        </h2>
      </div>
    </div>
    :
    <>
      <div className="p-2 flex flex-col flex-1 pb-5">
        <div className="flex justify-between mb-3">
          <PageTitle title={"Payment Methods"} tag="h6" />
          <Button title={"Add Payment Method"} />
        </div>
        <NoData />
      </div>
    </>
  );
};

export default PaymentMethods;
